import {Component} from '@angular/core';
import {NgClass, ViewportScroller} from '@angular/common';
import {Event, NavigationEnd, Router, RouterModule} from '@angular/router';

import {SidebarComponent} from '../../common/sidebar/sidebar.component';
import {HeaderComponent} from '../../common/header/header.component';
import {FooterComponent} from '../../common/footer/footer.component';
import {ToggleService} from '../../common/sidebar/toggle.service';
import {CustomizerSettingsService} from '../../customizer-settings/customizer-settings.service';

@Component({
  standalone: true,
  imports: [RouterModule, NgClass, SidebarComponent, HeaderComponent, FooterComponent],
  // selector: 'app-root',
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent {
  // Title
  title = 'Daxa - Angular 18 Material Design Admin Dashboard Template';

  // isSidebarToggled
  isSidebarToggled = false;

  // isToggled
  isToggled = false;

  constructor(
    public router: Router,
    private toggleService: ToggleService,
    private viewportScroller: ViewportScroller,
    public themeService: CustomizerSettingsService
  ) {
    this.router.events.subscribe((event: Event): void => {
      if (event instanceof NavigationEnd) {
        // @TODO: eduardo: ver como hacer esto
        if (!event.url.match(/^\/tournaments\/\d+\?tab=\d+/)) {
          // Scroll to the top after each navigation end
          // @TODO: no borrar esta linea
          this.viewportScroller.scrollToPosition([0, 0]);
        }
      }
    });
    this.toggleService.isSidebarToggled$.subscribe(isSidebarToggled => {
      this.isSidebarToggled = isSidebarToggled;
    });
    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });
  }
}
